import React, { FC } from 'react'
import { ModalButton } from '../../../../../../unansweredQuestions/styles'
import { TrainButtonState } from '../../../../../../unansweredQuestions/util/button'
import { RemoveButton } from '../../../../../styles'
import { ButtonProps } from './buttons-props'
import { SelectQuestionType } from './select-question-type'

export const TrainingQuestionButtons: FC<ButtonProps> = ({
  onUpdateQuestion,
  onDelete,
  buttonIsActive,
  setSelectedQuestionType,
  initQuestionType,
}) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 'auto', gap: '10px' }}>
      <SelectQuestionType
        questionCallback={setSelectedQuestionType}
        value={initQuestionType}
      />
      <ModalButton
        onClick={onUpdateQuestion}
        state={buttonIsActive ? TrainButtonState.ACTIVE : TrainButtonState.INACTIVE}>
        Retrain
      </ModalButton>
      <RemoveButton disabled={false} style={{}} onClick={onDelete}>
        Delete
      </RemoveButton>
    </div>
  )
}
